import {TemplateQuery} from '@github-ui/issue-create/CreateIssue'
import type {CreateIssueQuery} from '@github-ui/issue-create/CreateIssueQuery'
import {getSelectedTemplate} from '@github-ui/issue-create/use-handle-template-change'
import {useQuery} from '@github-ui/react-query'
import {type Environment, fetchQuery, useRelayEnvironment} from 'react-relay'

export function useDraftIssueFormTemplateQuery({repoId, filename}: {repoId: string; filename: string}) {
  const environment = useRelayEnvironment()

  return useQuery({
    queryKey: ['copilot-immersive-template-payload', JSON.stringify(environment), repoId, filename],
    queryFn: async () => {
      if (!repoId || !filename) {
        return null
      }

      return await fetchTemplate(environment, repoId, filename)
    },
  })
}

// TODO this should live with the template picker
export async function fetchTemplate(environment: Environment, repoId: string, filename: string) {
  const response = await fetchQuery<CreateIssueQuery>(environment, TemplateQuery, {
    repoId,
    filename,
  }).toPromise()

  if (!response || !response.node) {
    return null
  }

  return getSelectedTemplate(response.node) ?? null
}
